module.exports = __webpack_public_path__ + "static/img/img_9.2440e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events_gallery/img_9.jpg
// module id = nk5P
// module chunks = 0